import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

import BlockDebugButtonComponent from 'webapp/components/block/debug-button';
import ReportsViewerBlockCtComponent from 'webapp/components/reports/viewer/block-ct';

import type ReportSlideFragment from 'webapp/models-custom/report-slide-fragment';

export interface Args {
	model: ReportSlideFragment;
	// onRemove: () => void;
	changeBlockFragmentToEdit: (fragment: ReportSlideFragment | null) => void;
	onFragmentChange: () => Promise<unknown>;
}

export default abstract class ReportsEditorBlockCtComponent extends Component<Args> {
	@service('popup') declare popupService: Service.Popup;

	@action
	editBlock(): void {
		this.args.changeBlockFragmentToEdit(this.args.model);
	}

	@action
	triggerFragmentChange() {
		void this.args.onFragmentChange();
	}

	@action
	bindBlockChange() {
		const blockSetup = this.args.model.block?.blockSetup;
		if (blockSetup) {
			blockSetup.registerEvent(this.triggerFragmentChange);
		}
	}

	override willDestroy(): void {
		super.willDestroy();
		const blockSetup = this.args.model.block?.blockSetup;
		if (blockSetup) {
			blockSetup.unregisterEvent(this.triggerFragmentChange);
		}
	}
	<template>
		<ReportsViewerBlockCtComponent
			@model={{@model}}
			@isEditable={{true}}
			@onClick={{this.editBlock}}
			@onBlockReady={{this.bindBlockChange}}
		>
			<BlockDebugButtonComponent @blockId={{@model.blockId}} />

		</ReportsViewerBlockCtComponent>
	</template>
}
